import { ROUTES } from "@/routes";
import { File, History, Home, LucideProps, Wrench } from "lucide-react";
import { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import { Link, LinkProps } from "react-router-dom";
import { opcenter } from "../../../config.json";

interface NavigationItem {
  Icon: ComponentType<LucideProps>;
  title: string;
  link: LinkProps["to"];
}

export function Navigation() {
  const { t } = useTranslation();

  const items: NavigationItem[] = [
    {
      Icon: Home,
      title: t("nav.home"),
      link: ROUTES.OPCENTER(opcenter.home, t("nav.home")),
    },
    {
      Icon: File,
      title: t("nav.workOrders"),
      link: ROUTES.OPCENTER(opcenter.workOrders, t("nav.workOrders")),
    },
    {
      Icon: Wrench,
      title: t("nav.deviations"),
      link: ROUTES.OPCENTER(opcenter.deviations, t("nav.deviations")),
    },
    {
      Icon: History,
      title: t("nav.applicationLog"),
      link: ROUTES.OPCENTER(opcenter.applicationLog, t("nav.applicationLog")),
    },
  ];

  return (
    <nav>
      <ul className="px-2 flex flex-col gap-6 pt-2">
        {items.map(({ Icon, link, title }) => (
          <li key={title}>
            <Link to={link} className="flex items-center gap-3 text-sm">
              <Icon className="h-6 w-6" strokeWidth={1.5} />
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
